import React, { Fragment } from 'react';

import { GridRenderCellParams } from '@mui/x-data-grid';
import { Switch } from '@mui/material';

export const renderRoles = (
  params: GridRenderCellParams<any, any, any>,
  onToggleUserRole: (email: string, role: string, shouldAssign: boolean) => Promise<void>
) => {

  const hasRole = (role: string) => {
    return params.row.roles.includes(role);
  }

  const email = params.row.email;

  const onChange = (e: any) => {
    const shouldAssignRole = e.target.checked;
    onToggleUserRole(email, params.field, shouldAssignRole);
  };

  return (
    <Fragment>
      <Switch checked={hasRole(params.field)} onChange={onChange}></Switch>
    </Fragment>
  );
}
